<template>
  <div class="container">
    <h1>知图用户协议</h1>
    <p>
      知图学术平台（以下简称知图或本平台）（<a href="http://test.sozdata.com//"
        >http://test.sozdata.com//</a
      >）所提供的各项服务和内容的所有权、著作权和营运权均归北京搜知数据科技有限公司所有。如果用户使用我们的产品或服务，便视为完全同意本服务协议内容。如果您不同意以下内容，请立刻停止访问本平台。
    </p>
    <h2>1、使用规则</h2>
    <h3>1.1用户应遵守以下法律及法规</h3>
    <p>
      （1）用户应遵守中华人民共和国有关法律、法规，承担一切因用户行为直接或间接引起的法律责任。在任何情况下，知图认为用户的行为可能违反国家法律、法规，可以不经事先通知终止向该用户提供服务；
    </p>
    <p>
      （2）用户如不在国内居住，还应特别注意遵守所在国家和地区有关的法律和法规。
    </p>

    <h3>1.2关于用户名的管理</h3>
    <p>
      （1）请勿以党和国家领导人或其他名人的姓名、字、号、艺名、笔名、头衔等注册和使用昵称；
    </p>
    <p>
      （2）请勿以国家组织机构、国际组织或其他组织机构的名称、简称等注册和使用昵称（如确为该机构，需要提交相关证据并通过审核方可允许使用）；
    </p>
    <p>（3）请勿注册和使用不文明、不健康及有违社会公序良俗的昵称；</p>
    <p>
      （4）请勿注册和使用易产生歧义、引起他人误解或带有各种奇形怪状符号的昵称；
    </p>
    <p>（5）其他法律、法规禁止或导致社会不良影响的昵称。</p>

    <h3>1.3知图禁止的行为</h3>
    <p>
      用户在知图发布信息时，必须遵守国家有关法律规定，并承担一切因自己发布不当导致的法律责任。用户在知图所发布的信息，不得含有以下内容：
    </p>
    <p>（1）违反法律、法规强制性规定或含有法律、行政法规禁止的其他内容的；</p>
    <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>（3）损害国家荣誉和利益的，攻击党和政府及其领导人的；</p>
    <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p>
      （5）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的，以非法民间组织名义活动的；
    </p>
    <p>（6）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>（7）散布谣言或不实消息，扰乱社会秩序，破坏社会稳定的；</p>
    <p>（8）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>
      （9）违背中华民族传统美德、社会公德、伦理道德、以及社会主义精神文明的；
    </p>
    <p>（10）宣扬种族歧视，破坏国家、民族、地区团结的言论和消息的；</p>
    <p>（11）侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的；</p>
    <p>（12）恶意重复、大量发布各种信息的；</p>
    <p>（13）未经知图同意，张贴任何形式广告的；</p>
    <p>（14）利用本平台进行故意制作、传播计算机病毒等破坏性程序；</p>
    <p>
      （15）发布信息时，任何人不得以任何原因对任何一位用户或公民进行人身攻击、侮辱、谩骂、诋毁、中伤、恐吓等。不得侵害他人合法权益.
    </p>
    <p>
      如用户在知图发布信息时，不遵守协议中的规定，本平台有权修改、删除用户发布的任何信息，并有权对违反协议的用户做出封禁ID；或暂时、永久禁止在本平台发布信息的处罚，同时保留依法追究当事人法律责任的权利。知图系统记录将作为用户违反法律的证据。
    </p>

    <h2>2、知识产权</h2>
    <div className="noIndent">
      2.1用户在知图上发表的非知图付费原创内容（包括但不仅限于回答、文章和评论），著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要知图同意。
    </div>
    <div className="noIndent">
      2.2
      知图向专家进行付费签约的内容（如专家解读模块等），所有参与者均同意相关知识产权归知图所有。用户在未经知图允许的情况下，不得将此内容转载、复制或非法使用。
    </div>
    <div className="noIndent">
      2.3
      知图提供的网络服务中包含的标识、版面设计、排版方式、文本、图片、图形等均受著作权、商标权及其它法律保护，未经相关权利人（知图及其他原始权利人）同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。
    </div>
    <div className="noIndent">
      2.4
      为了促进知识的分享和传播，用户将其在知图上发表的全部内容，授予知图免费的、不可撤销的、非独家使用许可。知图有权将该内容用于知图各种形态的产品和服务上，包括但不限于网站以及发表的应用或其他互联网产品。
    </div>
    <div className="noIndent">
      2.5
      第三方若出于非商业目的，将用户在知图上发表的内容转载在知图之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在知图上使用的帐号名称），并给出原始链接，注明「发表于知图」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。
    </div>
    <div className="noIndent">
      2.6
      在知图上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，知图有权核实实际情况并删除相关内容，且有权追究用户的法律责任。因此给知图或任何第三方造成损失的，知图有权要求用户全额赔偿。
    </div>

    <h2>3、隐私保护</h2>
    <div className="noIndent">
      3.1
      知图不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在本平台的非公开内容，但下列情况除外：
    </div>
    <p>（1）事先获得用户的明确授权；</p>
    <p>（2）根据有关的法律法规要求；</p>
    <p>（3）按照相关政府主管部门的要求；</p>
    <p>（4）为维护社会公众的利益。</p>

    <div className="noIndent">
      3.2
      知图可能会与第三方合作向用户提供相关的服务，在此情况下，如该第三方同意承担与知图同等的保护用户隐私的责任，则知图有权将用户的注册资料等提供给该第三方。
    </div>
    <div className="noIndent">
      3.3
      在不透露单个用户隐私资料的前提下，本平台有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
    </div>

    <h2>4、免责声明</h2>
    <div className="noIndent">
      4.1 知图不能对用户发表的回答或评论的真实性、正确性进行保证。
    </div>
    <div className="noIndent">
      4.2
      用户在知图发表的内容仅表明其个人的立场和观点，并不代表知图的立场或观点。作为内容的发表者，需自行对所发表内容负责。因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。知图不承担任何法律责任。如知图因此涉及诉讼或仲裁或行政处理，知图有权追究用户法律责任。
    </div>
    <div className="noIndent">
      4.3
      知图不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。
    </div>
    <div className="noIndent">
      4.4 对于因不可抗力或知图不能控制的原因造成的网络服务中断或其它缺陷，
      知图不承担任何责任，但知图将尽力减少因此而给用户造成的损失和影响。
    </div>

    <h2>5、协议修改</h2>
    <p>
      本平台将可能不时修改本协议的有关条款。一旦条款内容发生变动，本平台将会在相关的页面提示修改内容。如果不同意本平台对服务条款所做的修改，用户有权停止使用知图。如果用户继续使用知图，则视为用户接受服务条款的变动。
    </p>
    <p>知图对本协议项下的内容有最终解释权。</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
  width: 1000px;
  margin: 0 auto;
  line-height: 30px;
  font-size: 16px;
  font-family: "Microsoft yahei";
  h1 {
    text-align: center;
    height: 80px;
    line-height: 80px;
    font-size: 20px;
    font-weight: bold;
  }
  h2,
  h3,
  h4,
  h5 {
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: bold;
  }
  p {
    text-indent: 32px;
    margin-bottom: 10px;
  }
  .noIndent {
    margin-bottom: 10px;
  }
}
</style>